import React from "react"
import { motion } from "framer-motion"
import { LoadingOverlay } from "@mantine/core"
const StatCard = ({ name, icon: Icon, value, color, loading = false }: any) => {
  return (
    <motion.div
      className="bg-gray-800 bg-opacity-50 backdrop-blur-md overflow-hidden shadow-lg rounded-xl border border-gray-700"
      whileHover={{ y: -5, boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)" }}
    >
      <LoadingOverlay visible={loading} />
      <div className="px-4 py-5 sm:p-6">
        <span className="flex items-center text-sm font-medium text-gray-400">
          <Icon className="mr-2" style={{ color }} />
          {name}
        </span>
        <p className="mt-1 text-3xl font-semibold text-gray-100">
          {value ?? 0}
        </p>
      </div>
    </motion.div>
  )
}

export default StatCard
